import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "features/config/store";

interface InitialState {
  sidebarStatus: boolean;
  processEditProductButton: boolean;
  processEditInfoButton: boolean;

  processConfirmEditButton: boolean;
  processClose: boolean;
  processPlaceOrderEditButton: boolean;
  processStockEditProductNInfo: boolean;
}

const initialState: InitialState = {
  sidebarStatus: true,
  processEditInfoButton: false,
  processEditProductButton: false,
  processConfirmEditButton: false,
  processClose: false,
  processPlaceOrderEditButton: false,
  processStockEditProductNInfo: false,
};

export const stockOrderGlobalTriggerSlice = createSlice({
  name: "stockOrderGlobalTrigger",
  initialState,
  reducers: {
    // Sidebar trigger
    openstockOrderSideBar: (state) => {
      state.sidebarStatus = true;
    },
    closestockOrderSideBar: (state) => {
      state.sidebarStatus = false;
    },
    togglestockOrderSideBar: (state) => {
      state.sidebarStatus = !state.sidebarStatus;
    },

    // Confirm edit button
    openStockProcessConfirmEditButton: (state) => {
      state.sidebarStatus = false;
    },
    toggleStockProcessConfirmEditButton: (state) => {
      state.processConfirmEditButton = !state.processConfirmEditButton;
    },

    //Edit button process products
    toggleStockProcessProductEditButton: (state) => {
      state.processEditProductButton = !state.processEditProductButton;
    },
    openStockProcessProductEditButton: (state) => {
      state.processEditProductButton = true;
    },

    closeStockProcessProductEditButton: (state) => {
      state.processEditProductButton = false;
    },

    //Edit button process info
    toggleStockProcessInfoEditButton: (state) => {
      state.processEditInfoButton = !state.processEditInfoButton;
    },
    openStockProcessInfoEditButton: (state) => {
      state.processEditInfoButton = true;
    },

    closeStockProcessInfoEditButton: (state) => {
      state.processEditInfoButton = false;
    },

    // Process close button
    closeStockProcess: (state) => {
      state.processClose = true;
    },
    openStockProcess: (state) => {
      state.processClose = false;
    },

    // Edit Place order
    toggleStockProcessPlaceOrderEditButton: (state) => {
      state.processPlaceOrderEditButton = !state.processPlaceOrderEditButton;
    },
  },
});

export const selectstockOrderGlobalTrigger = (state: RootState) =>
  state.stockOrderGlobalTrigger;

export const {
  openstockOrderSideBar,
  closestockOrderSideBar,
  togglestockOrderSideBar,

  openStockProcessConfirmEditButton,
  toggleStockProcessConfirmEditButton,

  closeStockProcessProductEditButton,
  openStockProcessProductEditButton,
  toggleStockProcessProductEditButton,

  closeStockProcessInfoEditButton,
  openStockProcessInfoEditButton,
  toggleStockProcessInfoEditButton,

  closeStockProcess,
  openStockProcess,

  toggleStockProcessPlaceOrderEditButton,
} = stockOrderGlobalTriggerSlice.actions;

export default stockOrderGlobalTriggerSlice.reducer;
